// extracted by mini-css-extract-plugin
export default {"container":"OrSeparator_container__zzbf+","bar":"OrSeparator_bar__SSyyq","orLabel":"OrSeparator_orLabel__TfeCu"};